import { render } from "./VehicleProd.vue?vue&type=template&id=639d568b&ts=true"
import script from "./VehicleProd.vue?vue&type=script&lang=ts"
export * from "./VehicleProd.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__